import { showInput } from './showInput';
import { postInsertComment, getCommentById, getCommentList } from '../services';
import { message as toast } from '@src/mobile/components/ModalBox';

export const replyComment = ({ replyName = '', subjectId, rootId = '0', pId = '0', callback }) => {
    showInput({
        replyName,
        callback: async comment => {
            try {
                const res = await postInsertComment({ subjectId, comment, rootId, pId });

                if (res && res.status === 200 && res.data) {
                    const { code, message } = res.data;

                    if (code === 200 && message) {
                        toast({ content: '评论已发送' });
                        const res = await getCommentById({ commentId: message, subjectId });

                        if (res && res.status === 200 && res.data) {
                            const { code, data } = res.data;

                            if (code === 200 && data) {
                                callback(data);
                            }
                        }
                    } else {
                        // TODO: 评论未成功提示
                    }
                }
            } catch (e) {
                console.error(e);
            }
        },
    });
};

// 处理评论列表每一项之间的回复关系
export const addReplyUser = (comments = []) => {
    if (Array.isArray(comments) && comments.length) {
        comments.forEach(comment => {
            if (comment?.pid !== comment?.rootId) {
                const target = comments.find(item => item?.id === comment?.pid);

                if (target) {
                    comment.replyUser = target.commentUserName;
                }
            }
        });
    }
};

export const getList = async ({ subjectId, page, pageSize, sort, rootId }) => {
    try {
        const res = await getCommentList({ subjectId, page, pageSize, sort, rootId });

        if (res && res.status === 200 && res.data) {
            const { code, data } = res.data;

            if (code === 200 && data) {
                const { pagination, list } = data;
                const { current, pageSize, total } = pagination;

                // 处理评论回复者之间的关系
                list.forEach(item => {
                    addReplyUser(item.comments);
                });

                return { list, current, pageSize, total };
            }
        }
    } catch (e) {
        console.error(e);
    }

    return {};
};
